<template>
	<div class='' :class='{ "!max-w-[300px]": minimised }'>
		<div class='w-full flex items-center text-17 font-hero h-13 text-white bg-black stroke-white pl-6 pr-2.5 justify-between'
			:class='[headerCSS]'
		>
			<slot name='title' />

			<div class='flex items-center gap-2'>
				<slot name='header-buttons-left' />

				<button @click='minimise' v-if='canMinimise' type='button' id='modal-close' class='w-7 h-7 flex items-center justify-center'>
					<component :is='minimised ? "IconMiniArrowUp" : "IconMinus"' class='w-4.5 h-4.5 hover:opacity-80' />
				</button>

				<button @click='close' v-if='! minimised' 
					type='button' id='modal-close' class='w-7 h-7 flex items-center justify-center'>
					<IconClose class='w-4.5 h-4.5 hover:opacity-80' />
				</button>
			</div>
		</div>

		<!-- style='height: calc(100% - 52px);' -->
		<!-- overflow-scroll w-full -->

		<Form class='modal-form-fix' :class='[formCSS]'
			:action='action' 
			:method='method'
			@onSubmitted='submitted'
			@onError='onError'
			v-slot='{ saving, errors }'
			v-if='! minimised'
			ref='form'
		>
			<slot :saving='saving' :errors='errors' />
		</Form>
	</div>
</template>

<script>
	export default {
		props: {
			action: String,
			submittedCallback: {
				type: Function,
				default: null
			},
			headerCSS: { type: String, default: '' },
			formCSS: { type: String, default: 'p-6' },
			canMinimise: { type: Boolean, deafult: false },
			toast: { type: [String, Function], default: null },
			getUserAfterSave: { type: Boolean, default: false },
			method: { type: String, default: 'POST' },
		},

		emits: ['close', 'minimise'],

		methods: {
			close() {
				this.$event.$emit('modal-close')
			},

			minimise() {
				this.$emit('minimise')
			},

			onError() {
				this.$emit('onError')
			},

			submit() {
				this.$refs.form.submit();
			},

			submitted(res, event) {
				if (this.toast != null) {
					this.$event.$emit('toast-new-message', this.toast)
				}

				if (this.submittedCallback != null) {
					this.submittedCallback(res, event);
					return;
				}

				if (this.getUserAfterSave) {
					this.$authSanctum.getUser(true);
				}

				this.$event.$emit('modal-form-completed')
				this.$event.$emit('modal-close')
			},
		},

		computed: {
			minimised() {
				return this.$parent.minimised
			}
		}
	}
</script>